import { NotificationCode } from 'app/common/model/notification-code';

export class StudyNotificationEvent {

    constructor(
        public studyNotificationEventId: number,
        public studySchemaEvent: NotificationCode
      ) {}
}
